export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            关于我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8">了解91樱花动漫平台</p>
          <div className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-8 text-left">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
              91樱花创立于2019年，是一家专注于动漫内容聚合与分发的在线平台。我们致力于为动漫爱好者提供<strong className="text-foreground-900 font-semibold">高质量、全品类、无删减</strong>的动漫观看与下载服务。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
              平台目前已收录超过<strong className="text-foreground-900 font-semibold">20000部</strong>动漫作品，涵盖日漫、国漫、剧场版、OVA等全品类内容。无论是经典老番还是当季新番，你都能在这里找到。我们坚持<strong className="text-foreground-900 font-semibold">每日同步更新</strong>，确保追番用户第一时间看到最新内容。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
              在画质方面，91樱花全站提供<strong className="text-foreground-900 font-semibold">1080P超清画质</strong>，热门番剧更支持4K选项。多线路CDN加速确保播放流畅不卡顿，下载速度快且支持断点续传。我们重视每一位用户的追番体验，持续优化产品功能。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              作为国内领先的动漫平台之一，91樱花始终坚持<strong className="text-foreground-900 font-semibold">免费、完整、安全</strong>的运营理念，所有内容无需会员即可观看，无删减保留原汁原味的剧情，为动漫迷打造最好的追番家园。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}